import { render } from "./MinimumReviewTime.vue?vue&type=template&id=d1f5e47a&scoped=true"
import script from "./MinimumReviewTime.vue?vue&type=script&lang=js"
export * from "./MinimumReviewTime.vue?vue&type=script&lang=js"

import "./MinimumReviewTime.vue?vue&type=style&index=0&id=d1f5e47a&scoped=true&lang=css"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1f5e47a"]])

export default __exports__